"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AgsAssessment = void 0;
var constants_1 = require("../constants");
/**
 * It contains information about the assessment
 *
 * @property {string}                id                          - identifier for the assessment
 * @property {string}                contextId                       - the user owning this assessment. The user who assigned the template
 * @property {AssessmentTemplate}    title          - associated assessment template
 * @property {string}                assessmentClass             - represents the assessment class where it was assigned
 * @property {boolean}               curriculum                  - flag to indicate if the assessment has auto launch
 * @property {string[]}              sharedUserIds               - user ids which the assessment template has been shared with
 * @property {Date}                  endDate                     - assessment end date
 * @property {Date}                  startDate                   - assessment start date
 * @property {Date}                  assignedDate                  - assessment assign date
 * @property {Date}                  avgScore                  - assessment finish/close date
 * @property {number}                maxScore               - number of students assigned to the assessment
 * @property {number}                createdAt              - number of students who have submitted the assessment
 * @property {*}                     createdBy                    - assessments settings used to override the template settings
 * @property {string}                updatedAt                        - assessment type
 * @property {string}                status                      - assessment status. Possible values: draft, assigned, completed
 * @property {string}                updatedBy                    - used to group assessments in bundles, a bundle is a group of assessments
 *
 * @author javier.perez
 */
var AgsAssessment = /** @class */ (function () {
    function AgsAssessment(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    AgsAssessment.prototype.isDigitalProduct = function () {
        return this.productId === constants_1.ProductId.Digital;
    };
    return AgsAssessment;
}());
exports.AgsAssessment = AgsAssessment;
